import React, { Component } from 'react';
import DefaultGrid from '../../../components/DefaultGrid';
import { TextArea } from 'devextreme-react';
import CrudForm from '../../../template/CrudForm';
import Form, { SimpleItem, GroupItem } from 'devextreme-react/form';
import API from '../../../services/AplicationService';
import { showSuccessMessage, showConfirmationMessage, handleError } from '../../../utils/Utility';
import * as messages from '../../../utils/Messages';
import '../../../utils/Messages';

const masterProps = {
	title: 'Cadastro de Produtos',
	subtitle: 'Gerencie o cadastro de produtos',
};
const initialState = {
	product: { id: null, name: '', description: '', enabled: true },
	term: '',
};
export default class Product extends Component {
	state = { ...initialState };
	product = { id: null, name: '', description: '', enabled: true };
	constructor(props) {
		super(props);
		this.loadListProducts = this.loadListProducts.bind(this);
		this.getProduct = this.getProduct.bind(this);
		this.deleteProduct = this.deleteProduct.bind(this);
		this.onClickSearch = this.onClickSearch.bind(this);
		this.onClickNew = this.onClickNew.bind(this);
		this.onClickSave = this.onClickSave.bind(this);
		this.setStateDataToInitial = this.setStateDataToInitial.bind(this);
		this.saveProduct = this.saveProduct.bind(this);
		this.dataGrid = React.createRef();
		this.crudForm = React.createRef();
		this.form = React.createRef();
	}
	getProduct(key) {
		this.crudForm.current.showLoadingPanel(true);
		API.get('products/' + key)
			.then(response => {
				this.product = { ...response.data };
				this.setState({ ...this.state, product: this.product });
				this.crudForm.current.setActiveTabIndex(1);
			})
			.catch(error => {
				handleError(error, messages.errorGetData);
			})
			.then(() => {
				this.crudForm.current.showLoadingPanel(false);
			});
	}
	deleteProduct(key) {
		API.delete('products/' + key)
			.then(response => {
				showSuccessMessage(messages.successDeleteData);
				this.setStateDataToInitial();
				this.dataGrid.current.reloadData();
			})
			.catch(error => {
				handleError(error, messages.errorDeleteData);
			});
	}
	saveProduct() {
		this.crudForm.current.showLoadingPanel(true);
		let product = { ...this.product };
		if (product.id === null) {
			API.post('products/', product)
				.then(response => {
					showSuccessMessage(messages.successInsertData);
					product = response.data;
					this.product = product;
					this.setState({ product: this.product });
					// console.log(this.product);
					//this.setStateDataToInitial();
					this.dataGrid.current.reloadData();
				})
				.catch(error => {
					handleError(error, messages.errorInsertData);
					this.dataGrid.current.reloadData();
				})
				.then(() => {
					this.crudForm.current.showLoadingPanel(false);
				});
		} else {
			API.put('products/' + product.id, product)
				.then(response => {
					showSuccessMessage(messages.successUpdateData);
					this.product = product;
					this.setState({ product: this.product });
					this.dataGrid.current.reloadData();
				})
				.catch(error => {
					handleError(error, messages.errorUpdateData);
				})
				.then(() => {
					this.crudForm.current.showLoadingPanel(false);
				});
		}
	}
	loadListProducts(page, pageSize) {
		let term = this.state.term;
		return API.get('/products', {
			params: {
				page: page,
				pageSize: pageSize,
				term: term,
			},
		})
			.then(response => {
				let result = {
					data: response.data.products,
					totalCount: response.data.totalRegisters,
				};

				return result;
			})
			.catch(error => {
				handleError(error, messages.errorListData);
			});
	}
	renderGrid() {
		return (
			<React.Fragment>
				<DefaultGrid
					ref={this.dataGrid}
					pageSize={50}
					keyField={'id'}
					showBorders={true}
					fncDeleteData={this.deleteProduct}
					fncGetData={this.getProduct}
					fncListData={this.loadListProducts}
					defaultColumns={[
						{ dataField: 'id', caption: 'Código', width: '5%' },
						{ dataField: 'name', caption: 'Nome', width: '60%' },
						{ dataField: 'description', caption: 'Descrição' },
						{ dataField: 'enabled', caption: 'Ativo', width: '10%' },
					]}
					buttons={[
						{
							name: 'edit',
							hint: 'delete',
							icon: 'fa fa-edit',
							visible: true,
						},
						{
							name: 'delete',
							hint: 'Excluir',
							icon: 'fa fa-trash',
							visible: true,
						}
					]}
							/>
			</React.Fragment>
		);
	}
	setStateDataToInitial() {
		this.product = { ...initialState.product };
		this.setState({ ...this.state, product: this.product });
	}
	onClickSearch = function(e) {
		this.dataGrid.current.reloadData();
	};
	onClickSave = function() {
		this.saveProduct();
	};
	onClickNew = function() {
		showConfirmationMessage(messages.questionNewOperation, this.setStateDataToInitial);
	};
	renderFilter() {
		return (
			<Form formData={this.state} colCount={7}>
				<GroupItem colSpan={6}>
					<SimpleItem
						dataField={'term'}
						cssClass="uppercase"
						editorOptions={{ placeholder: 'Digite o que deseja procurar...' }}
						label={{ text: 'Buscar por', showColon: false, visible: false }}
					/>
				</GroupItem>
				<GroupItem>
					<button onClick={this.onClickSearch} type="button" className="btn btn-info btn-block">
						<i className="fa fa-search" />
						&nbsp; Buscar
					</button>
				</GroupItem>
			</Form>
		);
	}
	renderForm() {
		return (
			<Form formData={this.product} ref={this.form} showColonAfterLabel={false} labelLocation={'left'}>
				<GroupItem>
					<GroupItem colCount={7}>
						<SimpleItem
							dataField={'id'}
							cssClass="uppercase"
							label={{ text: 'Código' }}
							editorOptions={{ disabled: true }}
						/>
						<SimpleItem dataField={'enabled'} editorType={'dxCheckBox'} label={{ text: 'Ativo' }} />
					</GroupItem>
					<GroupItem>
						<SimpleItem dataField={'name'} cssClass="uppercase" label={{ text: 'Nome' }} />
						<SimpleItem
							dataField={'description'}
							editorType={'dxTextArea'}
							label={{ text: 'Descrição' }}
							editorOptions={{ inputAttr: { rows: 10 } }}
						/>
					</GroupItem>
					<GroupItem>
						<div className="pull-right">
							{/* <button
								type="button"
								className={
									this.state.showCancel === false ? 'hidden' : 'btn btn-right-space btn-danger'
								}
								onClick={this.onClickCancel}
							>
								<i className="fa fa-ban" />
								&nbsp; Cancelar
							</button> */}
							<button type="button" className="btn btn-right-space btn-primary" onClick={this.onClickNew}>
								<i className="fa fa-plus" />
								&nbsp; Novo
							</button>
							<button type="button" className="btn btn-success" onClick={this.onClickSave}>
								<i className="fa fa-check" />
								&nbsp; Salvar
							</button>
						</div>
					</GroupItem>
				</GroupItem>
			</Form>
		);
	}
	render(props) {
		masterProps.form = this.renderForm();
		masterProps.dataGrid = this.renderGrid();
		masterProps.filter = this.renderFilter();
		return <CrudForm {...masterProps} ref={this.crudForm} />;
	}
}
